import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { InnerHtmlWrapper } from '../utils/InnerHtmlWrapper';
import { stackStyles } from './renderers';
import * as i18next from "i18next";

import React = require('react');

export let status_thank_you_renderer = (input: string) => {
    return (
    <Stack styles={stackStyles}>
        <Stack className="styled-text form__message">
                <InnerHtmlWrapper className="text--l" text={input} />
        </Stack>
    </Stack>
    )
}

export let status_sending_renderer = () => {
    return (
    <Stack styles={stackStyles}>
        <Stack>
            <Text variant={'mediumPlus'} className="message">{i18next.t("ContactForm:Texts:SendingFormText")}</Text>
        </Stack>
    </Stack>
    )
}

export let status_error_renderer = () => {
    return (
    <Stack styles={stackStyles}>
        <Stack>
            <Text variant={'mediumPlus'} className="message message--error">{i18next.t("ContactForm:Texts:ErrorSendingFormText")}</Text>
        </Stack>
    </Stack>
    )
}